export default __webpack_public_path__ + "static/media/TaskComplete.4872dda0.svg";